import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import client from "./client";
import API_ENDPOINTS from "../constants/api-endpoints";

type CB = { onSuccess?: (r: any) => void; onError?: (e: any) => void };

export const useAnnouncements = (params: any = {}) =>
  useQuery({
    queryKey: ["announcements", params],
    queryFn: () => client.get(API_ENDPOINTS.ANNOUNCEMENTS, { params }).then((r) => r.data.data as any[]),
    refetchOnWindowFocus: false,
  });

export const useAnnouncementCreate = ({ onSuccess, onError }: CB = {}) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => client.post(API_ENDPOINTS.ANNOUNCEMENTS, data),
    onSuccess: (r) => { qc.invalidateQueries({ queryKey: ["announcements"] }); onSuccess?.(r); },
    onError: (e) => onError?.(e),
  });
};

export const useAnnouncementUpdate = ({ onSuccess, onError }: CB = {}) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: any }) =>
      client.put(API_ENDPOINTS.ANNOUNCEMENT_UPDATE(id), data),
    onSuccess: (r) => { qc.invalidateQueries({ queryKey: ["announcements"] }); onSuccess?.(r); },
    onError: (e) => onError?.(e),
  });
};

export const useAnnouncementDelete = ({ onSuccess, onError }: CB = {}) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => client.delete(API_ENDPOINTS.ANNOUNCEMENT_DELETE(id)),
    onSuccess: (r) => { qc.invalidateQueries({ queryKey: ["announcements"] }); onSuccess?.(r); },
    onError: (e) => onError?.(e),
  });
};
